var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat-color-icons:google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.8368 10.5415H21.0312V10.5H12.0312V14.5H17.6828C16.8583 16.8285 14.6427 18.5 12.0312 18.5C8.71775 18.5 6.03125 15.8135 6.03125 12.5C6.03125 9.1865 8.71775 6.5 12.0312 6.5C13.5608 6.5 14.9523 7.077 16.0118 8.0195L18.8403 5.191C17.0542 3.5265 14.6652 2.5 12.0312 2.5C6.50875 2.5 2.03125 6.9775 2.03125 12.5C2.03125 18.0225 6.50875 22.5 12.0312 22.5C17.5538 22.5 22.0312 18.0225 22.0312 12.5C22.0312 11.8295 21.9622 11.175 21.8368 10.5415Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.18457 7.8455L6.47007 10.255C7.35907 8.054 9.51207 6.5 12.0316 6.5C13.5611 6.5 14.9526 7.077 16.0121 8.0195L18.8406 5.191C17.0546 3.5265 14.6656 2.5 12.0316 2.5C8.19057 2.5 4.85957 4.6685 3.18457 7.8455Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0312 22.4999C14.6142 22.4999 16.9612 21.5114 18.7357 19.9039L15.6407 17.2849C14.603 18.074 13.335 18.5009 12.0312 18.4999C9.43022 18.4999 7.22172 16.8414 6.38972 14.5269L3.12872 17.0394C4.78372 20.2779 8.14472 22.4999 12.0312 22.4999Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.8368 10.5415H21.0312V10.5H12.0312V14.5H17.6828C17.2884 15.6082 16.5779 16.5766 15.6392 17.2855L15.6407 17.2845L18.7358 19.9035C18.5168 20.1025 22.0312 17.5 22.0312 12.5C22.0312 11.8295 21.9622 11.175 21.8368 10.5415Z",
    fill: "#1976D2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/iconGoogle.ba6660e51094e45cd0506d72c7e72e9b.svg";
export { ForwardRef as ReactComponent };